import { z } from 'zod/v3'
import { createFileRoute, Link } from '@tanstack/react-router'
import { PageHeaderBreadcrumb } from '@/components/layout/PageHeaderActions'
import { SystemDescriptionContent } from '@/components/screenata/SystemDescriptionForm'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/statement-of-applicability'
)({
  component: StatementOfApplicabilityPage,
  validateSearch: z.object({
    testId: z.string().trim().min(1).optional(),
  }),
  staticData: { pageHeader: { title: 'Statement of Applicability', pad: false } },
})

function StatementOfApplicabilityPage() {
  const { testId } = Route.useSearch()
  const { workspaceId } = Route.useParams()

  return (
    <>
      {testId && (
        <PageHeaderBreadcrumb>
          <Link
            to='/workspaces/$workspaceId/controls'
            params={{ workspaceId }}
            search={{ test: testId }}
            className='font-heading text-text-subtle hover:text-foreground text-[15px] font-medium'
          >
            Back to Test
          </Link>
        </PageHeaderBreadcrumb>
      )}
      <SystemDescriptionContent deliverableKey='statement_of_applicability' />
    </>
  )
}
